import { useQuery } from 'react-query'
import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'
import { get } from 'lodash'

const useUserCourses = ({
    userId,
    limit,
    offset,
    startDate,
    endDate,
    view = 'enrolled',
}) => {

    const cacheKeys = useCacheKeys()
    const { time, api, endpoints, url, formatDate } = useApi()

    const sd = formatDate(startDate)
    const ed = formatDate(endDate)

    const filters = {
        limit,
        offset,
        sd,
        ed,
        view,
    }

    const { data, isLoading } = useQuery(
        [cacheKeys.COURSES, userId, filters], 
        () => api.get(url(endpoints.userCourses, { userId }, filters)),
        { 
            enabled: Boolean(userId),
            refetchIntervalInBackground: true,
            refetchInterval: time.MINUTE * 5,
        }
    )

    return {
        isLoading,
        courses: get(data, 'items', []),
    }
}

export default useUserCourses